(function () {
  'use strict';

  function bindPress(el) {
    if (!el || el.dataset.mbLangPressReady) return;
    el.dataset.mbLangPressReady = '1';

    el.addEventListener('pointerdown', function () {
      el.classList.add('is-pressed');
    });

    function pressOff() {
      el.classList.remove('is-pressed');
    }

    el.addEventListener('pointerup', pressOff);
    el.addEventListener('pointerleave', pressOff);
    el.addEventListener('pointercancel', pressOff);
  }

  function bindOption(link) {
    if (!link || link.dataset.mbLangOptionReady) return;
    link.dataset.mbLangOptionReady = '1';

    link.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    link.addEventListener(
      'click',
      function (event) {
        var form = link.closest('form');
        var input = form && form.querySelector('input[name="locale_code"]');
        var value = link.getAttribute('data-value');
        if (!form || !input || !value) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        input.value = value;
        if (link.href) {
          window.location.assign(link.href);
          return;
        }
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('.mb-lang-switcher__trigger, .mb-lang-switcher__option').forEach(bindPress);
    document.querySelectorAll('.mb-lang-switcher__option').forEach(bindOption);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
